import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { CountriesAction } from "../../../../store/actions";
import useScreenSize from "../../../../utils/usescreensize";
import RemoveEmptyKeys from "../../../../utils/removeemptykeys";
import {
  getArrayParam,
  getNumberParam,
  setArrayParam,
  setNumberParam,
} from "../../../../utils/urlsearchparams";
import EditProfileBoxLabel from "../../../label/editprofileboxlabel";
import EditProfileMultipleSelect from "../../../dropdown/editprofilemultipleselection";
import BasicSearchMultipleSelectCountry from "../../../dropdown/basicsearchmultipleselectcountry";
import CheckboxGroup from "../../../checkbox/checkboxgroup";
import RangeSlider from "../../../rangeslider/rangeslider";
import PrimaryButton from "../../../button/primarybutton";
import Spacer from "../../../spacer/spacer";

import {
  maritalStatusMale,
  maritalStatusFemale,
  spokenLanguages,
} from "../../../../utils/arrayitems";

import images from "../../../../assets";
import "../styles.css";
import UnderHeaderMenu from "../../../underheadermenu";

const typeofProfile = [
  { label: "Doesn't matter", value: "Doesn't matter" },
  { label: "Verified", value: "Verified" },
  { label: "Premium", value: "Premium" },
  { label: "Basic", value: "Basic" },
];
const activityStatus = [
  { label: "All", value: "All" },
  { label: "Online", value: "Online" },
  { label: "Offline", value: "Offline" },
];

const BasicSearchItems = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const screenSize = useScreenSize();
  const [searchParams, setSearchParams] = useSearchParams();

  const { countries, states } = useSelector((state) => state.countries);
  const gender = useSelector((state) => state.profile?.profile?.gender);
  const filterParamsKey = [
    "ageMin",
    "ageMax",
    "country",
    "stateProvince",
    "maritalStatus",
    "spokenLanguage",
    "typeofProfile",
    "activityStatus",
  ]
    .map((key) => searchParams.getAll(key).join(","))
    .join("|");

  const [state, setState] = useState({
    ageMin: 18,
    ageMax: 30,
    country: [],
    stateProvince: [],
    maritalStatus: [],
    spokenLanguage: [],
    typeofProfile: [],
    activityStatus: [],
  });

  useEffect(() => {
    setState({
      ageMin: getNumberParam(searchParams, "ageMin", 18),
      ageMax: getNumberParam(searchParams, "ageMax", 30),
      country: getArrayParam(searchParams, "country", []),
      stateProvince: getArrayParam(searchParams, "stateProvince", []),
      maritalStatus: getArrayParam(searchParams, "maritalStatus", []),
      spokenLanguage: getArrayParam(searchParams, "spokenLanguage", []),
      typeofProfile: getArrayParam(searchParams, "typeofProfile", []),
      activityStatus: getArrayParam(searchParams, "activityStatus", []),
    });
  }, [filterParamsKey]);

  const handleClear = () => {
    const params = new URLSearchParams(searchParams);
    [
      "ageMin",
      "ageMax",
      "country",
      "stateProvince",
      "maritalStatus",
      "spokenLanguage",
      "typeofProfile",
      "activityStatus",
      "page",
    ].forEach((key) => params.delete(key));
    setSearchParams(params);
  };

  useEffect(() => {
    if (!state?.country) return;

    const payload = { country: state?.country };
    dispatch(CountriesAction.getStates(payload));
  }, [state?.country]);

  const handleSearch = () => {
    const searchData = RemoveEmptyKeys(state);
    const params = new URLSearchParams(searchParams);
    setNumberParam(params, "ageMin", searchData.ageMin);
    setNumberParam(params, "ageMax", searchData.ageMax);
    setArrayParam(params, "country", searchData.country);
    setArrayParam(params, "stateProvince", searchData.stateProvince);
    setArrayParam(params, "maritalStatus", searchData.maritalStatus);
    setArrayParam(params, "spokenLanguage", searchData.spokenLanguage);
    setArrayParam(params, "typeofProfile", searchData.typeofProfile);
    setArrayParam(params, "activityStatus", searchData.activityStatus);
    setNumberParam(params, "page", 1);

    screenSize.width < 1023 && props?.setOpen(false);
    setSearchParams(params);
  };

  return (
    <div className={"sidebar-full sidebar"}>
      {screenSize.width < 1023 && (
        <UnderHeaderMenu {...props} titlename="Standard Search">
          <p className="cursor-pointer" onClick={handleClear}>
            Clear
          </p>
        </UnderHeaderMenu>
      )}

      <div className="sidebar-logo-container-basic hidden lg:block">
        <img
          src={images.mainLogo}
          alt="logo"
          onClick={() => navigate("/dashboard")}
          style={{ cursor: "pointer" }}
        />
      </div>

      <div
        style={{
          height: "90vh",
          overflowY: "auto",
          overflowX: "hidden",
          width: "100%",
        }}
      >
        <div className="hidden lg:block">
          <PrimaryButton
            text={"Menu"}
            icon={images.arrowIconLeft}
            iconalign="left"
            style={{ width: "120px" }}
            onClick={() => props?.setBasicSearchMenu(false)}
          />
          <Spacer height="20px" />
          <h1 className="sidebar-basic-search-title">Standard Search</h1>
        </div>

        <Spacer height="16px" />
        {/* country */}
        <div className="edit-profile-label-container">
          <EditProfileBoxLabel label="Age Range" />
        </div>
        <Spacer height="8px" />
        <div className="px-3">
          <RangeSlider
            onChange={(e) => setState({ ...state, ageMin: e[0], ageMax: e[1] })}
            value={[state.ageMin, state.ageMax] || ""}
          />
        </div>
        <Spacer height="12px" />
        {/* country */}
        <div className="edit-profile-label-container">
          <EditProfileBoxLabel label="Country" />
        </div>
        <Spacer height="8px" />
        <BasicSearchMultipleSelectCountry
          placeholder="Country"
          data={countries}
          onChange={(e) => {
            setState({ ...state, country: e });
          }}
          value={state.country || undefined}
        />
        <Spacer height="12px" />
        {/* state */}
        <div className="edit-profile-label-container">
          <EditProfileBoxLabel label="State / Province" />
        </div>
        <Spacer height="8px" />
        <BasicSearchMultipleSelectCountry
          placeholder="States"
          data={states}
          onChange={(e) => {
            setState({ ...state, stateProvince: e });
          }}
          value={state.stateProvince || undefined}
        />
        <Spacer height="12px" />

        {/* Marital Status */}
        <div className="edit-profile-label-container">
          <EditProfileBoxLabel label="Marital Status" />
        </div>
        <Spacer height="8px" />
        <EditProfileMultipleSelect
          placeholder="Marital Status"
          data={
            gender === "male"
              ? [
                  {
                    label: "Doesn't matter",
                    value: "",
                  },
                  ...maritalStatusFemale,
                ]
              : [
                  {
                    label: "Doesn't matter",
                    value: "",
                  },
                  ...maritalStatusMale,
                ]
          }
          onChange={(e) => {
            setState({ ...state, maritalStatus: e });
          }}
          value={state.maritalStatus || undefined}
        />
        <Spacer height="12px" />

        {/* Spoken Language */}
        <div className="edit-profile-label-container">
          <EditProfileBoxLabel label="Spoken Language" />
        </div>
        <Spacer height="8px" />
        <EditProfileMultipleSelect
          placeholder="Spoken Language"
          data={[
            {
              label: "Doesn't matter",
              value: "",
            },
            ...spokenLanguages,
          ]}
          onChange={(e) => {
            setState({ ...state, spokenLanguage: e });
          }}
          value={state.spokenLanguage || undefined}
        />
        <Spacer height="12px" />

        {/* checkbox part container */}
        <div className="basic-search-sidebar-checkbox">
          <div>
            {/*typeofprofile */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Type of Profile" />
            </div>
            <Spacer height="8px" />
            <CheckboxGroup
              items={typeofProfile}
              value={state.typeofProfile || undefined}
              onChange={(selected) => {
                let updated = selected || [];
                if (updated.includes("Doesn't matter") && updated.length > 1) {
                  // If "Doesn't matter" selected along with others, keep only "Doesn't matter"
                  updated = ["Doesn't matter"];
                } else if (!updated.includes("Doesn't matter")) {
                  // If something else selected while "Doesn't matter" was selected before, remove it
                  updated = updated.filter((val) => val !== "Doesn't matter");
                }
                setState({ ...state, typeofProfile: updated });
              }}
            />
          </div>

          <div>
            {/*activity status */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Activity Status" />
            </div>
            <Spacer height="8px" />
            <CheckboxGroup
              items={activityStatus}
              value={state.activityStatus || undefined}
              onChange={(selected) => {
                let updated = selected || [];
                if (updated.includes("All") && updated.length > 1) {
                  updated = ["All"];
                } else if (!updated.includes("All")) {
                  updated = updated.filter((val) => val !== "All");
                }
                setState({ ...state, activityStatus: updated });
              }}
            />
          </div>
        </div>
        <Spacer height="32px" />
        <PrimaryButton text={"Search"} onClick={handleSearch} />
        <Spacer height="100px" />

        <p
          style={{
            fontSize: "14px",
            fontWeight: "400",
            color: "#8993A4",
            textAlign: "center",
          }}
          className="hidden lg:block"
        >
          Or use{" "}
          <span
            className="purple-text"
            onClick={() => navigate("/advanced-search")}
            style={{
              fontSize: "14px",
              fontWeight: "400",
              color: "#BA0060",
              textDecoration: "underline",
            }}
          >
            Advanced Search
          </span>
        </p>
      </div>
    </div>
  );
};

export default BasicSearchItems;
